var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"animated-number"},[(_vm.pop)?_c('transition',{attrs:{"name":"number-punch","mode":"out-in"}},[_c('span',{key:_vm.tweeningValue.toLocaleString('en'),staticClass:"anim"},[_vm._v(" "+_vm._s(_vm.tweeningValue.toLocaleString('en'))+" ")])]):_c('span',[_vm._v(_vm._s(_vm.tweeningValue.toLocaleString('en')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }